var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AbstractDataTableReport } from './abstract-data-table-report';
import { cloneDeep } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import Report from '../../../model/entity/report/report';
export class AbstractProjectDataTableReport extends AbstractDataTableReport {
    constructor(serviceContainer, project) {
        super(serviceContainer);
        this.id = uuidv4();
        this.savedDefaultColumns = null;
        this.project = project;
    }
    prepare() {
        return __awaiter(this, void 0, void 0, function* () {
            // Load saved default columns
            yield this.loadDefaultColumns();
            // Mark as prepared
            this.prepared = true;
        });
    }
    /**
     * Loads saved saved searches for this report
     *
     * @returns
     */
    loadSavedSearches() {
        return __awaiter(this, void 0, void 0, function* () {
            // Load the saved searches
            const savedSearches = yield this.serviceContainer.reportService.findReports({
                project: this.project.id,
                report: this.id,
            });
            // Convert to SavedSearchInterface for the data table component
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const savedSearchInterfaces = cloneDeep(savedSearches);
            savedSearchInterfaces.results = [];
            for (const savedSearch of savedSearches.results) {
                savedSearchInterfaces.results.push(savedSearch.toSavedSearchInterface());
            }
            return savedSearchInterfaces;
        });
    }
    /**
     * Saves a search
     *
     * @param search
     * @returns
     */
    saveSearch(search) {
        return __awaiter(this, void 0, void 0, function* () {
            const report = Report.createFromSavedSearchInterface(search);
            report.project = this.project.id;
            report.report = this.id;
            let savedReport;
            if (search.id) {
                savedReport = yield this.serviceContainer.reportService.updateReport(report);
            }
            else {
                savedReport = yield this.serviceContainer.reportService.createReport(report);
            }
            // Restore the pinned status as it's not part of the report itself since it's user based
            savedReport.pinned = search.pinned;
            return savedReport.toSavedSearchInterface();
        });
    }
    /**
     * Deletes a saved search
     *
     * @param id
     */
    deleteSavedSearch(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.serviceContainer.reportService.deleteReport(id);
        });
    }
    /**
     * Pins a saved search
     *
     * @param id
     */
    pinSavedSearch(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.serviceContainer.reportService.pinReport(id);
        });
    }
    /**
     * Unpins a saved search
     *
     * @param id
     */
    unpinSavedSearch(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.serviceContainer.reportService.unpinReport(id);
        });
    }
    /**
     * Loads default report columns for a user
     */
    loadDefaultColumns() {
        return __awaiter(this, void 0, void 0, function* () {
            this.savedDefaultColumns = yield this.serviceContainer.reportService.loadUserDefaultColumns(this.id, this.project.id);
        });
    }
    /**
     * Saves default report columns for a user
     *
     * @param columns
     * @param global
     */
    saveDefaultColumns(columns, global) {
        return __awaiter(this, void 0, void 0, function* () {
            // Update locally for instant feedback
            this.savedDefaultColumns = columns;
            // Save
            this.serviceContainer.reportService.saveUserDefaultColumns(this.id, columns, global ? null : this.project.id);
        });
    }
}
//# sourceMappingURL=abstract-project-data-table-report.js.map